import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Hydrate } from '@tanstack/react-query';
import { FeaturesProvider } from '@wkda/feature-toggle';
import Cookies from 'universal-cookie';
import { AppConfigurationContainer } from '../hooks/useAppConfiguration';
import { PageDataContainer } from '../hooks/usePageData';
import { ModulesContainer } from '../hooks/useModules';
import TranslationsProvider from '../TranslationsProvider';
import { CookiesProvider } from '../hooks/useCookies';
import { ErrorsProvider } from '../hooks/useResponseErrors/useResponseErrors';
/**
 *
 * @typedef {import('@wkda/internal-types').IBaseAppConfig} AppConfig
 */

/**
 *
 * @param {{
 *  features: AppConfig['features'];
 *  locale: import('@wkda/internal-types').AppLocales;
 *  appConfig: AppConfig;
 *  initialData: any;
 *  modules: import('@wkda/funnel-modules').Modules;
 *  activateLocale?: Function;
 *  children: React.ReactNode;
 *  queryClient: import('@tanstack/react-query').QueryClient;
 *  req?: import('express').Request
 * }} props
 */

export default function AppContainers(_ref) {
  let {
    features,
    locale,
    appConfig: config,
    initialData,
    modules,
    activateLocale,
    children,
    queryClient,
    req
  } = _ref;
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(Hydrate, {
    state: initialData.dehydratedState
  }, /*#__PURE__*/React.createElement(CookiesProvider, {
    cookies: req ? new Cookies(req.headers.cookie) : undefined
  }, /*#__PURE__*/React.createElement(FeaturesProvider, {
    value: {
      config: features,
      locale
    }
  }, /*#__PURE__*/React.createElement(AppConfigurationContainer, {
    data: config
  }, /*#__PURE__*/React.createElement(PageDataContainer, {
    data: initialData
  }, /*#__PURE__*/React.createElement(ModulesContainer, {
    data: modules
  }, /*#__PURE__*/React.createElement(ErrorsProvider, null, /*#__PURE__*/React.createElement(TranslationsProvider, {
    locale: locale,
    onActivate: activateLocale
  }, children)))))))));
}